// pages/FormViewerPage/hooks/useFormViewer/submitDuplicate.ts — Duplicate-key post-submit recovery
import { supabase } from '../../../../supabase/client';
import { storePhoneLast4 } from '../../../../hooks/useThankYouPage/fetchOrder';

export async function handleDuplicateKey(params: {
    formId: string | undefined;
    orderId: string;
    identifier: string;
    phone?: string;
    navigate: (path: string, opts?: any) => void;
    hasSubmittedRef: React.MutableRefObject<boolean>;
    setIsSubmitting: (v: boolean) => void;
    submitLockRef: React.MutableRefObject<boolean>;
}) {
    const { formId, orderId, identifier, phone, navigate, hasSubmittedRef, setIsSubmitting, submitLockRef } = params;
    hasSubmittedRef.current = true;
    if (formId) { try { await supabase.rpc('increment_form_submission', { p_form_id: formId }) } catch { /* */ } }
    if (phone) storePhoneLast4(orderId, phone);
    // submitDuplicate tidak punya form object, fallback ke thanks (confirm butuh form)
    navigate(`/f/${identifier}/thanks/${orderId}${window.location.search}`, { replace: true });
    setIsSubmitting(false);
    submitLockRef.current = false;
}
